// extracted by mini-css-extract-plugin
export default {"wrapper":"ComponentSelectList_wrapper__wDwT9"};